import { useEffect, useState } from "react";
import { getPartnerPortalDashboard } from "../api/partnerPortalApi";

export function useAutoMapaPartnerClientView(slug) {
  const [clientViewId, setClientViewId] = useState(null);
  const [clientView, setClientView] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!slug) {
      setClientViewId(null);
      setClientView(null);
      setLoading(false);
      return undefined;
    }

    let cancelled = false;

    async function load() {
      setLoading(true);
      setError("");
      try {
        const dashboard = await getPartnerPortalDashboard();
        const matchedView = (dashboard.clientViews || []).find((view) => view.slug === slug);
        if (!cancelled) {
          setClientView(matchedView || null);
          setClientViewId(matchedView?.clientViewId || null);
        }
      } catch (err) {
        if (!cancelled) {
          setClientView(null);
          setClientViewId(null);
          setError(err.message || "Unable to resolve client view.");
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    }

    load();
    return () => {
      cancelled = true;
    };
  }, [slug]);

  return { clientViewId, clientView, loading, error };
}
